import * as React from "react";
import { BsChevronRight, BsFlagFill } from "react-icons/bs";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import Store from "common/store";
import PicksHelper from "common/picksHelper";
import "./ChampionReminder.scss";

const propKeys = {
	eventData: StoreKeys.EVENT.EVENTDATA,
	format: StoreKeys.EVENT.FORMAT,
	view: StoreKeys.EVENT.VIEW,
	championPick: StoreKeys.EVENT.CHAMPION_PICK,
	bracketUser: StoreKeys.EVENT.BRACKET_USER,
	submittedStageIds: StoreKeys.EVENT.USER.SUBMITTED_STAGE_IDS,
};

function ChampionReminderC({
	eventData,
	format,
	view,
	championPick,
	bracketUser,
	submittedStageIds,
}) {
	const show =
		view !== "overview" &&
		!bracketUser &&
		(submittedStageIds ?? []).length > 0 &&
		!championPick?.teamId &&
		!new PicksHelper(eventData).isStarted();

	if (!show) {
		return <></>;
	}

	const points = Number(format.championPick?.points) || 0;

	const pickChampion = () => {
		const updates = {};
		updates[StoreKeys.EVENT.SCROLL_TO_TEAMS] = true;
		updates[StoreKeys.EVENT.VIEW] = "overview";
		Store.setMany(updates);
	};

	return (
		<div className="champion-reminder" onClick={pickChampion}>
			<BsFlagFill />
			<span className="reminder-text">
				<strong>No champion pick yet.</strong>
				{points > 0 && (
					<> Going All The Way pays +{points} points on top of your stage picks.</>
				)}
			</span>
			<span className="reminder-action">
				Pick champion
				<BsChevronRight />
			</span>
		</div>
	);
}

export default function ChampionReminder(props) {
	return connect(<ChampionReminderC />, propKeys, props);
}
